// Navigation sources
export const HOME_LOGO_CLICKED = 'logo';
export const HOME_SIDE_PANEL_CLICKED = 'side_panel';
export const HOME_LOGIN_NAV = 'login';
export const HOME_BACK_BUTTON_NAV = 'back_button';
export const HOME_DIRECT_LINK_NAV = 'direct_link';
